export const globalBackground = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#fdf8b1";
	}
	if (colorBackGround === "in_hiring") {
		return "#dcf7f1";
	}
	if (colorBackGround === "issued") {
		return "#ddffe9";
	}
	if (colorBackGround === "refused") {
		return "#ffdbdb";
	}
	if (colorBackGround === "canceled") {
		return "#ffdbdb";
	}
	if (colorBackGround === "expired") {
		return "#ffecdb";
	}
	if (colorBackGround === "provisioned") {
		return "#def4ff";
	}
	if (colorBackGround === "open") {
		return "#EBEDEF";
	}
	if (colorBackGround === "paid") {
		return "#ddffe9";
	}
	if (colorBackGround === "not_busy") {
		return "#b6f5dd";
	}
	if (colorBackGround === "busy") {
		return "#ffdbdb";
	}
	if (colorBackGround === "pre_approved") {
		return "#def4ff";
	}
	if (colorBackGround === "awaiting_signature") {
		return "#766E6C";
	}
	if (colorBackGround === "awaiting_biometria") {
		return "#defaff";
	}
	if (colorBackGround === "hired") {
		return "#def4ff";
	}
	return colorBackGround;
};

export const globalBackgroundPayment = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#edf8fe";
	}
	if (colorBackGround === "refused") {
		return "#ffb0b0";
	}
	if (colorBackGround === "canceled") {
		return "#ffecdb";
	}
	if (colorBackGround === "open") {
		return "#EBEDEF";
	}
	if (colorBackGround === "paid") {
		return "#ddffe9";
	}
	// if (colorBackGround === 'overdue') { return '#ffecdb' }
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}

	return colorBackGround;
};

export const globalBackgroundComission = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#edf8fe";
	}
	if (colorBackGround === "refused") {
		return "#ffb0b0";
	}
	if (colorBackGround === "canceled") {
		return "#ffecdb";
	}
	if (colorBackGround === "open") {
		return "#EBEDEF";
	}
	if (colorBackGround === "paid") {
		return "#ddffe9";
	}
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}

	return colorBackGround;
};

export const globalBackgroundSignature = (status: string = ""): string => {
	if (status === "running") {
		// Em processo
		return "#e0faff"; // azul claro suave
	}
	if (status === "closed") {
		// Finalizado
		return "#e9f8f5"; // verde claro suave
	}
	if (status === "canceled") {
		// Cancelado
		return "#fcedea"; // vermelho/rosa claro
	}
	if (status === "draft") {
		// Rascunho
		return "#EBEDEF"; // cinza claro
	}
	return status;
};

export const globalBackgroundFire = (status: string = ""): string => {
	if (status === "running") {
		// Em processo
		return "#e0faff"; // azul claro suave
	}
	if (status === "closed") {
		// Finalizado
		return "#e9f8f5"; // verde claro suave
	}
	if (status === "canceled") {
		// Cancelado
		return "#fcedea"; // vermelho/rosa claro
	}
	if (status === "draft") {
		// Rascunho
		return "#EBEDEF"; // cinza claro
	}
	if (status === "open") {
		return "#ddffe9";
	}
	if (status === "pending") {
		return "#fdf8b1";
	}
	if (status === "expired") {
		return "#ffecdb";
	}
	if (status === "canceling") {
		return "#fcedea";
	}
	if (status === "to_invoice") {
		return "#e3f2fd";
	}
	return status;
};


export const globalbackgroundProposal = (colorText: string = ""): string => {
	if (colorText === "active") {
		return "#e9f8f5";
	}
	if (colorText === "suspended") {
		return "#fcedea";
	}
	if (colorText === "renovated") {
		return "#e0faff";
	}
	if (colorText === "expired") {
		return "#fff4e5";
	}
	if (colorText === "canceled") {
		return "#fcedea";
	}
	return colorText;
};

export const globalColorTextProposal = (colorText: string = ""): string => {
	if (colorText === "active") {
		return "#43b897";
	}
	if (colorText === "suspended") {
		return "#e36b5b";
	}
	if (colorText === "expired") {
		return "#ed6c02";
	}
	if (colorText === "canceled") {
		return "#e36b5b";
	}
	if (colorText === "renovated") {
		return "#0f92d4";
	}
	return colorText;
};

export const globalColorTextSignature = (status: string = ""): string => {
	if (status === "running") {
		// Em processo
		return "#0f92d4"; // azul médio
	}
	if (status === "closed") {
		// Finalizado
		return "#43b897"; // verde
	}
	if (status === "canceled") {
		// Cancelado
		return "#e36b5b"; // vermelho/laranja
	}
	if (status === "draft") {
		// Rascunho
		return "#6c757d"; // cinza neutro
	}
	return status;
};

export const globalColorTextFire = (status: string = ""): string => {
	if (status === "running") {
		// Em processo
		return "#0f92d4"; // azul médio
	}
	if (status === "closed") {
		// Finalizado
		return "#43b897"; // verde
	}
	if (status === "canceled") {
		// Cancelado
		return "#e36b5b"; // vermelho/laranja
	}
	if (status === "draft") {
		// Rascunho
		return "#6c757d"; // cinza neutro
	}
	if (status === "open") {
		return "#0f8a0d";
	}
	if (status === "pending") {
		return "#f57c00";
	}
	if (status === "expired") {
		return "#ed6c02";
	}
	if (status === "canceling") {
		return "#e36b5b";
	}
	if (status === "to_invoice") {
		return "#0288d1";
	}
	return status;
};


export const globalColorText = (colorText: string = "", isOther: boolean = false, personalKey?: string): string => {
	if (colorText === "pending") {
		return "#1F618D";
	}
	if (colorText === "in_hiring") {
		return "#177d6b";
	}
	if (colorText === "issued") {
		return "#0f8a0d";
	}
	if (colorText === "refused") {
		return "#e40909";
	}
	if (colorText === "canceled") {
		return "#e40909";
	}
	if (colorText === "expired") {
		return "#e48509 ";
	}
	//if (colorText === 'overdue') { return '#e48509 ' }
	if (colorText === "overdue") {
		return "#e40909 ";
	}
	if (colorText === "busy") {
		return "#7924c7 ";
	}
	if (colorText === "provisioned") {
		return "#1F618D";
	}
	if (colorText === "open") {
		return "#5D6D7E";
	}
	if (colorText === "paid") {
		return "#0f8a0d";
	}
	if (colorText === "not_busy") {
		return "#0f8a0d";
	}
	if (!isOther && colorText === "active") {
		return "#38df61";
	}
	if (!isOther && colorText === "inactive") {
		return "#d3d3d3";
	}
	if (colorText === "blocked") {
		return "#878787";
	}
	if (colorText === "sent") {
		return "#f3f0f0";
	}
	if (colorText === "awaiting_signature") {
		return "#f3f0f0";
	}
	if (colorText === "awaiting_biometria") {
		return "#1F618D";
	}
	if (colorText === "hired") {
		return "#1F618D";
	}

	if (isOther && colorText === "active") {
		return "#f1f1f1";
	}
	if (isOther && colorText === "inactive") {
		return "#e40909";
	}

	return colorText;
};

export const globalColorTextReports = (colorText: string = ""): string => {
	if (colorText === "in_process") {
		return "#defaff";
	}
	if (colorText === "available") {
		return "#ddffe9";
	}

	if (colorText === "expired") {
		return "#ffdbdb";
	}

	return colorText;
};

export const globalColorTextSetup = (colorText: string = ""): string => {
	if (colorText === "paid") {
		return "#60DF96";
	}
	if (colorText === "pending") {
		return "#44BAF5";
	}

	if (colorText === "not_paid") {
		return "#28A7C6";
	}

	if (colorText === "canceled") {
		return "#E84933";
	}

	if (colorText === "billed") {
		return "#DBCC51";
	}

	return colorText;
};

export const globalBackgroundSetup = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#edf8fe";
	}
	if (colorBackGround === "refused") {
		return "#ffb0b0";
	}
	if (colorBackGround === "canceled") {
		return "#fcedea";
	}
	if (colorBackGround === "open") {
		return "#EBEDEF";
	}
	if (colorBackGround === "paid") {
		return "#ddffe9";
	}
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}
	if (colorBackGround === "client_paid" || colorBackGround === "paid_client") {
		return "#b6ece1ff";
	}

	return colorBackGround;
};

export const globalBackgroundPeople = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "inactive") {
		return "#fcedea";
	}

	if (colorBackGround === "active") {
		return "#ddffe9";
	}

	return colorBackGround;
};

export const globalColorPeople = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "inactive") {
		return "#eb3232";
	}
	if (colorBackGround === "active") {
		return "#1ec448";
	}

	return colorBackGround;
};

export const globalColorChipSetup = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#3761eb";
	}
	if (colorBackGround === "refused") {
		return "#eb3232";
	}
	if (colorBackGround === "canceled") {
		return "#eb3232";
	}
	if (colorBackGround === "open") {
		return "#878787";
	}
	if (colorBackGround === "paid") {
		return "#1ec448";
	}
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}
	if (colorBackGround === "client_paid" || colorBackGround === "paid_client") {
		return "#148f77";
	}

	return colorBackGround;
};

export const globalBackgroundNFSE = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#edf8fe";
	}
	if (["rejectted", "unauthorized", ""].includes(colorBackGround)) {
		return "#fcedea";
	}
	if (colorBackGround === "canceled") {
		return "#fff4e5";
	}
	if (colorBackGround === "open") {
		return "#EBEDEF";
	}
	if (["issued", "authorized", ""].includes(colorBackGround)) {
		return "#ddffe9";
	}
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}

	return colorBackGround;
};

export const globalColorNFSE = (colorBackGround: string, personalKey?: string): string => {
	if (colorBackGround === "pending") {
		return "#3761eb";
	}
	if (colorBackGround === "unauthorized") {
		return "#eb3232";
	}
	if (colorBackGround === "canceled") {
		return "#eb3232";
	}
	if (colorBackGround === "open") {
		return "#878787";
	}
	if (colorBackGround === "paid") {
		return "#1ec448";
	}
	if (colorBackGround === "overdue") {
		return "#ea080812";
	}

	return colorBackGround;
};

export function globalColorLine(line: number) {
	if (line % 2 == 0) {
		return "#f3f3f3";
	}
	return "#ffffff";
}

export function colorStatusProposal(status: string) {
	if (status === "expired") {
		return "#f0e555";
	}
	if (status === "active") {
		return "#38df61";
	}
	if (status === "canceled") {
		return "#eb3232";
	}
	if (status === "suspended") {
		return "#eb3232";
	}
	if (status === "renovated") {
		return "#3761eb";
	}
	if (status === "paid") {
		return "#1ec448";
	}
	if (status === "billed") {
		return "#3761eb";
	}

	return "#202020";
}

export function GlobalcolorBackGroundSinister(status: string) {
	if (status === "open") {
		return "#e4d9d9";
	}
	if (status === "provision") {
		return "#a9e9eb";
	}
	if (status === "refused") {
		return "#EEC5C5";
	}
	if (status === "accepted") {
		return "#C5EEC9";
	}
	if (status === "approved") {
		return "#C5EEC9";
	}
	if (status === "analysis") {
		return "#F4ECC0";
	}
	if (status === "canceled") {
		return "#EEC5C5";
	}

	return "#adadad";
}

export function GlobalCoolorIconSinister(status: string) {
	if (status === "created") {
		return "#e4870f";
	}
	if (status === "in_progress") {
		return "#12a6ac";
	}
	if (status === "finalized") {
		return "#12c224";
	}
	if (status === "pending") {
		return "#c4a80d";
	}
	if (status === "canceled") {
		return "#eb3232";
	}
	return "#202020";
}

export function GlobalColorTextSinister(status: string) {
	if (status === "created") {
		return "#e4870f";
	}
	if (status === "in_progress") {
		return "#12a6ac";
	}
	if (status === "in_analysis") {
		return "#1976D2";
	}
	if (status === "finalized") {
		return "#12c224";
	}
	if (status === "pending") {
		return "#c4a80d";
	}
	if (status === "canceled") {
		return "#eb3232";
	}

	if (status === "approved") {
		return "#027502";
	}

	if (status === "rejected") {
		return "#eb3232";
	}

	return "#202020";
}

export const globalColorTytle = "#1c1b1b";
export const globalColorInputBackGround = "#efe1ff";
